// assets/product-custom-property.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductCustomPropertyRefs
 * @property {HTMLInputElement | HTMLTextAreaElement} textInput - The text input.
 * @property {HTMLElement} characterCount - The character count element.
 */

/**
 * A custom element that manages product custom properties
 * @extends Component<ProductCustomPropertyRefs>
 */
class ProductCustomProperty extends Component {
  connectedCallback() {
    super.connectedCallback();
    const sendLater = this.querySelector('[data-measurement-send-later]');
    if (sendLater) {
      sendLater.addEventListener('change', () => this.#syncSendLater(sendLater));
      this.#syncSendLater(sendLater);
    }
  }

  handleInput() {
    this.#updateCharacterCount();
  }

  #updateCharacterCount() {
    const { characterCount, textInput } = this.refs;
    const currentLength = textInput.value.length;
    const maxLength = textInput.maxLength;

    const template = characterCount.getAttribute('data-template');
    if (!template) return;

    const updatedText = template
      .replace('[current]', currentLength.toString())
      .replace('[remaining]', Math.max(0, maxLength - currentLength).toString())
      .replace('[max]', maxLength.toString());

    characterCount.textContent = updatedText;
  }

  #syncSendLater(sendLater) {
    const field = this.querySelector('.custom-property__input');
    if (!field) return;

    field.disabled = sendLater.checked;
    field.required = sendLater.checked ? false : field.hasAttribute('aria-required');
    if (sendLater.checked) field.value = '';
  }
}

customElements.define('product-custom-property-component', ProductCustomProperty);
